import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, storeUtmParams, generateEventId } from "@/lib/fbPixel";
import { supabase } from "@/integrations/supabase/client";

declare global {
  interface Window {
    metaPageViewEventId?: string;
  }
}

export const useMetaTracking = () => {
  const location = useLocation();
  const hasTrackedInitialPageView = useRef(false);

  useEffect(() => {
    // Store UTM params on every route change
    storeUtmParams();

    // Track PageView for route changes (not initial load - that's handled by index.html)
    if (hasTrackedInitialPageView.current) {
      trackPageView();
    } else {
      // For initial page load, send CAPI event with the same event_id as the pixel
      hasTrackedInitialPageView.current = true;
      
      // Send initial PageView to CAPI with matching event_id for deduplication
      const eventId = window.metaPageViewEventId || generateEventId();
      
      supabase.functions.invoke("meta-capi", {
        body: {
          eventName: "PageView",
          eventId,
          eventTime: Math.floor(Date.now() / 1000),
          eventSourceUrl: window.location.href,
          userData: {
            client_user_agent: navigator.userAgent,
          },
          customData: {},
        },
      }).then(() => {
        console.log(`[Meta CAPI] Initial PageView sent with event_id: ${eventId}`);
      }).catch((error) => {
        console.error("[Meta CAPI] Error sending initial PageView:", error);
      });
    }
  }, [location.pathname]);
};
